import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'

export type EditDocumentVars = {
  title?: string
  slot_id?: string
  order_in_slot?: number
}

// Инвалидация — весь namespace документов: правка задевает detail и листинг
// владельца, а владелец документу известен только из read-view.
export function useEditDocument(documentId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: EditDocumentVars) =>
      apiRequest({ method: 'PATCH', url: `/documents/${documentId}`, body: vars }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['document'] })
    },
  })
}

export function useDeleteDocument(documentId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => apiRequest({ method: 'DELETE', url: `/documents/${documentId}` }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['document'] })
    },
  })
}
